import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdown", "button"];

  connect() {
    this.boundHandler = (e) => this.handleClickOutside(e);
    document.addEventListener("click", this.boundHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandler);
  }

  handleClickOutside(e) {
    if (
      this.isDropdownOpen() &&
      !this.dropdownTarget.contains(e.target) &&
      !this.buttonTarget.contains(e.target)
    ) {
      this.buttonTarget.click();
    }
  }

  isDropdownOpen() {
    return this.buttonTarget.ariaExpanded === "true";
  }
}
